















import { Component, Vue } from "vue-property-decorator";
import VesselComparison from "@/components/VesselComparison/VesselComparison.vue";

@Component({
  components: {
    VesselComparison,
  },
})
export default class VesselComparisonView extends Vue {

  get themeClass(): string {
    return this.$vuetify.theme.dark ? "theme--dark" : "theme--light";
  }
}
